import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import GoogleSignInButton from './shared/GoogleSignInButton';
import {
  getPublicAuthOrigin,
  isDistrictSubdomainHost,
  isOAuthAuthHost,
  isProductionMultiHostAuth
} from '../utils/authOrigin';
import AuthPageShell from './AuthPageShell';
import './Login.css';

const CompleteDistrictSignup = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithGoogle, navigateAfterGoogleLogin } = useAuth();
  const [error, setError] = useState('');

  const token = searchParams.get('token') || '';

  useEffect(() => {
    if (!isProductionMultiHostAuth()) return;
    if (!isOAuthAuthHost() && isDistrictSubdomainHost() && token) {
      const u = new URL(`${getPublicAuthOrigin()}/complete-district-signup`);
      u.searchParams.set('token', token);
      window.location.replace(u.toString());
    }
  }, [token]);

  const handleCredential = async (credential) => {
    setError('');
    if (!token.trim()) {
      setError('Missing invitation token. Open the link from your email.');
      return;
    }
    const result = await loginWithGoogle(credential, 'complete_district_invite', token.trim());
    if (result.success) {
      await navigateAfterGoogleLogin(result.user, navigate);
    } else {
      setError(result.error);
    }
  };

  return (
    <AuthPageShell>
      <div className="login-box">
        <h1>Back to School Forms</h1>
        <h2>Complete district sign-up</h2>
        <p style={{ marginBottom: '1rem', color: '#666', textAlign: 'center', fontSize: '0.95rem' }}>
          Sign in with the Google account that matches the email your district administrator used for this
          invitation.
        </p>
        {!token ? (
          <div className="error-message">This page needs a valid link from your invitation email.</div>
        ) : null}
        {error ? <div className="error-message">{error}</div> : null}
        <GoogleSignInButton text="continue_with" onCredential={handleCredential} />
        <div style={{ marginTop: '1.25rem', textAlign: 'center' }}>
          <Link to="/login" style={{ color: '#667eea', textDecoration: 'none', fontSize: '0.9rem' }}>
            Back to login
          </Link>
        </div>
      </div>
    </AuthPageShell>
  );
};

export default CompleteDistrictSignup;
